import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function SupportWidget() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="support-widget">
      {isOpen && (
        <div className="support-panel">
          <div className="support-panel-header">
            <h3>Yardım & Destek</h3>
            <p>Size nasıl yardımcı olabiliriz?</p>
          </div>
          <div className="support-panel-body">
            <Link to="/iletisim" className="support-option" onClick={() => setIsOpen(false)}>
              <div className="option-icon">📞</div>
              <div>
                <h4>İletişim</h4>
                <p>Satış ekibimize ulaşın</p>
              </div>
            </Link>
            <Link to="/destek" className="support-option" onClick={() => setIsOpen(false)}>
              <div className="option-icon">🎫</div>
              <div>
                <h4>Destek Merkezi</h4>
                <p>7x24 destek talebi oluşturun</p>
              </div>
            </Link>
            <a href="mailto:destek@emurinnovation.com" className="support-option">
              <div className="option-icon">✉️</div>
              <div>
                <h4>E-posta Desteği</h4>
                <p>destek@emurinnovation.com</p>
              </div>
            </a>
          </div>
        </div>
      )}
      <button className="support-toggle" onClick={() => setIsOpen(!isOpen)}>
        {isOpen ? '✕' : '💬'}
      </button>
    </div>
  );
}

export default SupportWidget;
